import request from '@/router/axios';
export function fetchList(query) {
  return request({
    url: '/api/blade-user/page',
    method: 'get',
    params: query
  });
}
export function addObj(obj) {
  return request({
    url: '/api/blade-user/submit',
    method: 'post',
    data: obj
  });
}
export function delObj(obj) {
  return request({
    url: '/api/blade-user/remove',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: obj
  });
}
export function putObj(obj) {
  return request({
    url: '/api/blade-user/update',
    method: 'post',
    data: obj
  });
}
export function putAlarmPush(obj) {
  return request({
    url: '/api/blade-user/alarmPush',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: obj
  });
}
export function getDetails(obj) {
  return request({
    url: '/api/admin/user/details/' + obj,
    method: 'get'
  });
}